<template>
    <div class="layout" id="myComponentDiv">
        <div class="box-titulo">ALIANZAS DE RECAUDOS</div>
        <div class="box-container">
            <div class="box-filtres">
                <table>
                    <tbody>
                    <tr>
                        <td style="height: 45px;">
                            Seleccione para activar recaudos en el entidad
                        </td>
                        <td width="40px" style="vertical-align: bottom; padding: 7px">
                            <div v-if="loading">
                                <img src="dist/img/kubber-loading.gif" style="width: 30px;" />
                            </div>
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>
            <div>
                <table id="table1" width="100%" class="table table-striped nowrap" style="width:100%">
                    <thead>
                        <tr>
                            <th width="200px">SELECCIONAR</th>
                            <th>ENTIDAD RECAUDADORA</th>
                            <th>FINANCIERA</th>
                            <th>ESTACION</th>
                            <th>ESTADO</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="item in reporte" :value="item._id" :key="item._id">
                            <td class="center">
                                <div v-if="person.perfil_id == GLOBAL.PERFILES.FINANCIERA">
                                    <input type="checkbox" :checked="item.firma_financiera != null"
                                        @change="handleClick(item, 'financiera')">
                                    Aliarse con Estación...
                                </div>
                                <div v-if="person.perfil_id == GLOBAL.PERFILES.ESTACION">
                                    <input type="checkbox" :checked="item.firma_estacion != null"
                                        @change="handleClick(item, 'estacion')">
                                    Aliarse con financiera...
                                </div>
                            </td>
                            <td>
                                <div>
                                    <b>{{ item.razon_social }}</b>
                                </div>
                                <div style="margin-top: -8px; font-size: 12px; color: blue;">
                                    {{ item.nombre }}
                                </div>
                            </td>
                            <td>{{ item.firma_financiera }}</td>
                            <td>{{ item.firma_estacion }}</td>
                            <td>{{ item.activo ? 'ACTIVO' : '' }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>

<script>
import GLOBAL from "../../Global.js";
import VehiculoService from "../Vehiculos/VehiculoService.js";


export default {

    data() {
        return {
            GLOBAL,
            person: null,
            vehiculo: null,
            tercero: null,
            cliente: "1042441916",
            placa: "MANTT0",
            loading: false,
            conversion: null,
            disableBotonGuardar: true,
            mensaje: '',
            reporte: [],
            acuerdo: null,
            clientes: [],
            is_FirmaFinanciera: false,
            is_FirmaEstacion: false,
        };
    },
    components: {},
    created() {

        this.person = JSON.parse(sessionStorage.getItem(GLOBAL.SESSION_KEY));

        this.permiso_lista = this.person.funciones.includes(GLOBAL.PERMISOS.REPORTE.HOROMETRO);
        this.reporteService = new VehiculoService();
        this.mensaje = ""
    },
    mounted() {
        $("input[datatype='fecha']").datepicker({
            onSelect: (dateText) => {
                this.actualizaComponente(dateText);
            }
        });
        this.getReporteEquipos()

    },
    methods: {

        handleClick(item, tipoFirma) {
            this.loading = true;

            // Indicamos qué tipo de firma se está haciendo
            item.firma_tipo = tipoFirma; // 'financiera' o 'estacion'

            if (this.person.perfil_id == GLOBAL.PERFILES.FINANCIERA) {
                item.financiera_un = this.person.empresa_id
            } else {
                item.estacion_un = this.person.empresa_id
            }

            this.reporteService.actualizarAlianzas(this.person, item).then(data => {
                if (data.status == 200) {
                    this.mensaje = "Firma registrada correctamente.";
                } else {
                    this.mensaje = typeof data.data !== "undefined" ? data.data : "No fue posible realizar la operación";
                }
            }).catch(() => {
                this.mensaje = "Error al realizar la operación";
            }).finally(() => {
                this.loading = false;
                this.getReporteEquipos();
            });
        },

        actualizaComponente(selected) {
            this.acuerdo.acuerdo_fecha = selected;
        },


        getReporteEquipos() {


            this.loading = true
            this.reporteService.getListaAlianzas(this.person).then(response => {
                console.log(response);
                this.reporte = []
                this.reporte = response.data;
                this.loading = false
            }).then(() => {

            })
        },



    }
}

</script>
